<template>
  <div class="wrap-carousel">
    <b-carousel
      indicators
    >
      <b-carousel-slide
        v-for="(banner, i) in banners"
        :key="i"
       
      >
        <template v-slot:img>
          <a :href="banner.link" target="_blank" rel="noopener noreferrer">
            <img
              :src="`${baseURL}/storage/app/img/banner/${isDesktop ? banner.banner_picture : banner.banner_picture_sm}`"
              :alt="banner.seo_alt || banner.banner_name || 'Adman Awards banner'"
              :loading="i === 0 ? 'eager' : 'lazy'"
              :fetchpriority="i === 0 ? 'high' : 'low'"
              decoding="async"
              style="width: 100vw;"
              :class="isDesktop ? 'wrap-carousel--desktop' : 'wrap-carousel--small'"
            >
          </a>
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'

export default {
  data () {
    return {
      isDesktop: window.matchMedia('(min-width: 1024px)').matches
    }
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      banners: state => state.banner.data
    })
  },

  methods: {
    handleBreakpointChange (event) {
      this.isDesktop = event.matches
    },

    getBannerApi () {
      let routeName = this.$route.name
      if (routeName === 'winnerArchive') {
        routeName = 'winners'
      }
      if (routeName === 'programArchive') {
        routeName = 'archive'
      }
      if (routeName === 'privacy') {
        routeName = 'archive'
      }
      if (!this.banners) {
        this.$store.dispatch('banner/get', routeName)
      }
    }
  },

  created () {
    this.getBannerApi()
  },

  mounted () {
    this.desktopMediaQuery = window.matchMedia('(min-width: 1024px)')

    if (this.desktopMediaQuery.addEventListener) {
      this.desktopMediaQuery.addEventListener('change', this.handleBreakpointChange)
    } else {
      this.desktopMediaQuery.addListener(this.handleBreakpointChange)
    }
  },

  beforeDestroy () {
    if (!this.desktopMediaQuery) return

    if (this.desktopMediaQuery.addEventListener) {
      this.desktopMediaQuery.removeEventListener('change', this.handleBreakpointChange)
    } else {
      this.desktopMediaQuery.removeListener(this.handleBreakpointChange)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.wrap-carousel {
  width: 100%;

  &--small {
    @media only screen and (min-width: $break-l) {
      display: none;
    }
  }

  &--desktop {
    display: none;

    @media only screen and (min-width: $break-l) {
      display: block;
    }
  }
}
</style>
